/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, Menu, MenuItem, Button, Stack, Divider, FormControlLabel } from '@mui/material';
import { MediaContext } from '../..';
import { LanguageContext } from '../../../../libs/Context';

const FilterMenu = ({ setMenuItem, menuItem, anchorEl, tab, filter }) =>
{
	const [ value, setValue ] = useState<any>(Array(6).fill(0));
	const [ tempValue, setTempValue ] = useState<any>(Array(6).fill(0));
	const { mediaState } = useContext(MediaContext);
	const { language } = useContext(LanguageContext);

	const filterList = [
		{ value: -1, lable: language?.all },
		{ value: 1, lable: language?.folders },
		{ value: 3, lable: language?.images },
		{ value: 5, lable: language?.videos },
		{ value: 2, lable: language?.documents },
		{ value: 4, lable: language?.audio }
	];
	const ITEM_HEIGHT = 60;
	const handleClose = () =>
	{
		setMenuItem({ type: 'setMenuItems', payload: { toggleFilter: menuItem.toggleFilter === 0 ? 1 : 0 } });
	};

	const handleClick = (e: any, checked) =>
	{
		let temp: any = [ ...tempValue ];
		const index = Number(e.target.value);

		if (index === -1)
		{
			temp = checked ? [ -1, 1, 2, 3, 4, 5 ] : Array(6).fill(0);
		}
		else
		{
			temp[index] = checked ? index : 0;
			temp[0] = [ 15 ].includes(temp.reduce((accumulator, currentValue) => (accumulator + (currentValue > 0 ? currentValue : 0)), 0)) ? -1 : 0;
		}
		setTempValue(temp);
	};

	const handleApply = () =>
	{
		const selectedFilters = tempValue.filter((item) => item > 0);

		if (selectedFilters.length === 0)
		{
			return;
		}
		setValue(tempValue);
		setMenuItem({ type: 'updateReducer', payload: { filter: selectedFilters.join(',') } });
		mediaState?.page > 0 && setMenuItem({ type: 'updateReducer', payload: { page: 0 } });
		setMenuItem({ type: 'breadCrumb' });
		handleClose();
	};

	const handleReset = () =>
	{
		const resetValue = [ -1, 1, 2, 3, 4, 5 ];

		setTempValue(resetValue);
	};

	useEffect(() =>
	{
		const temp:any = Array(5).fill(0);

		filter?.split(',').forEach((index) =>
		{
			temp[index] = Number(index);
		});

		temp[0] = temp.reduce((accumulator, currentValue) => accumulator + currentValue, 0) === 15 ? -1 : 0;

		setValue(temp);
		setTempValue(temp);
	}, []);

	return (

		<Menu
			anchorEl={anchorEl}
			id='long-menu'
			MenuListProps={{
				'aria-labelledby' : 'long-button'
			}}

			open={menuItem?.toggleFilter === 1}
			onClose={handleClose}
			PaperProps={{
				style : {
					maxHeight : 'none',
					width     : '22ch'
				}
			}}
			transformOrigin={{
				vertical   : 'top',
				horizontal : tab === 3 ? 110 : tab === 0 ? 240 : tab === 2 ? 220 : tab === 1 ? 223 : 350
			}}				anchorOrigin={{
				vertical   : 255,
				horizontal : 'right'
			}}
		>
			{filterList?.map((item: any) => (
				<MenuItem key={item?.value}>
					<FormControlLabel
						control={
							<Checkbox
								checked={tempValue.includes(item.value)}
								size='small'
								value={item?.value}
								onChange={handleClick}
							/>
						}
						label={<span className='subHeadingSM capitalTxt'>{item.lable}</span>}
						sx={{ width: '100%', margin: 0 }}
					/>
				</MenuItem>
			))}
			<Divider />
			<MenuItem disableRipple sx={{ padding: '8px 16px', '&:hover': { backgroundColor: 'transparent' }, cursor: 'default' }}>
				<Stack direction='row' spacing={1} width='100%' justifyContent='flex-end'>
					<Button
						size='small'
						variant='outlined'
						onClick={handleReset}
						disabled={JSON.stringify(tempValue) === JSON.stringify([ -1, 1, 2, 3, 4, 5 ])}
						sx={{ textTransform: 'capitalize' }}
					>
						{language?.reset || 'Reset'}
					</Button>
					<Button
						size='small'
						variant='contained'
						onClick={handleApply}
						disabled={tempValue.filter((item) => item > 0).length === 0 || JSON.stringify(tempValue) === JSON.stringify(value)}
						sx={{ textTransform: 'capitalize', color: 'white' }}
					>
						{language?.apply || 'Apply'}
					</Button>
				</Stack>
			</MenuItem>
		</Menu>
	);
};

export default FilterMenu;